<template>
  <section class="diensten-section">
    <div class="container">

      <div class="row justify-content-center">
        <div class="col-lg-7 text-center">
          <span class="section-label" v-reveal>{{ $t('services.label') }}</span>
          <h2 class="section-title" v-reveal="100">{{ $t('services.title') }}</h2>
          <p class="section-subtitle" v-reveal="180">{{ $t('services.subtitle') }}</p>
        </div>
      </div>

      <div class="row g-4 mt-2">

        <div class="col-lg-4 col-md-4" v-reveal="0">
          <div class="service-card service-card--featured" v-tilt="5">
            <div class="service-icon icon-blue">
              <i class="fas fa-rocket"></i>
            </div>
            <h3>{{ $t('services.web_title') }}</h3>
            <p>{{ $t('services.web_desc') }}</p>
          </div>
        </div>

        <div class="col-lg-4 col-md-4" v-reveal="120">
          <div class="service-card service-card--featured" v-tilt="5">
            <div class="service-icon icon-purple">
              <i class="fas fa-pencil-ruler"></i>
            </div>
            <h3>{{ $t('services.app_title') }}</h3>
            <p>{{ $t('services.app_desc') }}</p>
          </div>
        </div>

        <div class="col-lg-4 col-md-4" v-reveal="240">
          <div class="service-card service-card--featured" v-tilt="5">
            <div class="service-icon icon-green">
              <i class="fas fa-code-branch"></i>
            </div>
            <h3>{{ $t('services.solutions_title') }}</h3>
            <p>{{ $t('services.solutions_desc') }}</p>
          </div>
        </div>

      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ServicesComponent",
}
</script>

<style scoped>
/* Feathered dark veil: dims the pixel waves into a calm panel,
   fading in/out at the edges so there is never a hard section line. */
.diensten-section {
  padding: 7rem 0 6rem;
  background: linear-gradient(180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.55) 16%,
    rgba(0, 0, 0, 0.55) 84%,
    rgba(0, 0, 0, 0) 100%);
  position: relative;
}

.section-label {
  display: inline-block;
  font-family: 'JetBrains Mono', 'Courier New', monospace;
  font-size: 0.8rem;
  color: var(--accent);
  letter-spacing: 1px;
  margin-bottom: 0.875rem;
}

.section-title {
  font-family: 'Jersey 15', sans-serif;
  font-size: 2.75rem;
  color: var(--text);
  font-weight: 400;
  margin-bottom: 1rem;
  letter-spacing: 0;
}

.section-subtitle {
  color: var(--text-muted);
  font-size: 1.05rem;
  line-height: 1.7;
  margin-bottom: 0;
}

.service-card {
  background: linear-gradient(180deg, #151515, #0e0e0e);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius);
  padding: 2.1rem 1.9rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  transition: box-shadow 0.3s, border-color 0.3s;
  position: relative;
  overflow: hidden;
  transform-style: preserve-3d;
  box-shadow: 0 14px 44px rgba(0, 0, 0, 0.5), inset 0 1px 0 rgba(255, 255, 255, 0.06);
}

/* amber top accent line */
.service-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: var(--accent-grad);
  opacity: 0;
  transition: opacity 0.3s;
  z-index: 2;
}

/* cursor-tracking glow (uses --mx/--my from v-tilt) */
.service-card::after {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(300px circle at var(--mx, 50%) var(--my, 50%), var(--accent-tint), transparent 60%);
  opacity: 0;
  transition: opacity 0.3s;
  pointer-events: none;
  z-index: 1;
}

.service-card:hover::before { opacity: 1; }
.service-card:hover::after  { opacity: 1; }

.service-card > * { position: relative; z-index: 2; }

.service-card--featured {
  border-color: var(--border-strong);
}

.service-card:hover {
  box-shadow: 0 26px 60px rgba(0, 0, 0, 0.55), 0 0 40px var(--accent-tint);
  border-color: var(--accent-line);
}

.service-icon {
  width: 56px;
  height: 56px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;
  font-size: 1.4rem;
  transition: transform 0.2s;
}

.service-card:hover .service-icon {
  transform: scale(1.08);
}

.service-icon {
  background: var(--accent-tint);
  border: 1px solid var(--accent-line);
  color: var(--accent);
  box-shadow: 0 0 24px var(--accent-tint);
}
.icon-blue   { background: var(--accent-tint); color: var(--accent); }
.icon-purple { background: var(--accent-tint); color: var(--accent-soft); }
.icon-green  { background: var(--accent-tint); color: var(--accent); }

.service-card h3 {
  font-size: 1.2rem;
  color: var(--text);
  font-weight: 700;
  margin-bottom: 0.875rem;
}

.service-card p {
  color: var(--text-muted);
  font-size: 0.95rem;
  line-height: 1.7;
  margin-bottom: 0;
  flex: 1;
}

@media (max-width: 991px) { .diensten-section { padding: 5rem 0 4rem; } }
@media (max-width: 767px) {
  .diensten-section { padding: 4rem 0 3rem; }
  .section-title { font-size: 1.875rem; }
  .section-subtitle { font-size: 0.95rem; }
  .service-card { padding: 1.625rem 1.5rem; }
}
</style>
